/**
 * Resolves a path to a file in the public folder so images work
 * when the app is served from the root (/) or from a base path (e.g. /myapp/).
 */
export function publicUrl(path: string): string {
  const base = import.meta.env.BASE_URL
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  return base.endsWith('/') ? `${base}${cleanPath}` : `${base}/${cleanPath}`
}
